<div class="text-center">
  <boma-animation
    [animPath]="animationPath"
    [size]="animationSize"
  ></boma-animation>
  <p>{{ resultMessage }}</p>
  <p>{{ resultDescription }}</p>
</div>
